(function () {

  document.addEventListener('DOMContentLoaded', function () {

    /* ==============================
       🔹 Normalizar texto de color
    ============================== */
    function normalizeColor(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/[^a-z0-9]+/g, "_")     // todo lo raro → _
        .replace(/^_|_$/g, "");          // limpiar bordes
    }

    /* ==============================
       🔹 Ocultar swatches sin imagen
    ============================== */
    function hideEmptyColorOptions(drawer) {
      const optionItems = drawer.querySelectorAll('[style*="--option-color-image"]');

      optionItems.forEach(item => {
        const styleAttr = item.getAttribute('style');
        if (!styleAttr) return;

        const match = styleAttr.match(/--option-color-image:\s*url\((.*?)\)/);
        if (!match) return;

        const urlValue = match[1].replace(/['"]/g, '').trim();

        if (!urlValue) {
          item.style.display = 'none';
        }
      });
    }

    /* ==============================
       🔹 Eliminar imágenes duplicadas
    ============================== */
    function removeDuplicateSlides(gallery) {

      const slides = gallery.querySelectorAll('.product-quick-images__slide');
      const seen = new Set();

      slides.forEach(slide => {

        const img = slide.querySelector('img');
        if (!img) return;

        const src = img.src;

        if (seen.has(src)) {
          slide.remove(); // elimina duplicado real
        } else {
          seen.add(src);
        }

      });
    }

    /* ==============================
       🔹 Función principal
    ============================== */
    function updateQuickViewImages(drawer, variantId) {

      if (!drawer || !variantId) return;

      const gallery = drawer.querySelector('.product-quick-images');
      if (!gallery) return;

      hideEmptyColorOptions(drawer);

      const activeLabel = drawer.querySelector('.form__label__value');
      if (!activeLabel) return;

      const rawColor = activeLabel.textContent.trim();
      const color = normalizeColor(rawColor);

      const slides = gallery.querySelectorAll('.product-quick-images__slide');

      // Ocultar todos primero
      slides.forEach(slide => {
        slide.style.display = 'none';
        slide.classList.remove('is-active');
      });

      const matching = gallery.querySelectorAll(
        `[data-group="color_${color}"]`
      );

      /* ==============================
         🔹 Si encuentra grupo por color
      ============================== */
      if (matching.length > 0) {

        matching.forEach((slide, i) => {
          slide.style.display = 'block';
          if (i === 0) slide.classList.add('is-active');
        });

      } else {

        /* ==============================
           🔹 Si NO hay grupo → mostrar default
        ============================== */

        slides.forEach((slide, i) => {
          slide.style.display = 'block';
          if (i === 0) slide.classList.add('is-active');
        });

      }

      removeDuplicateSlides(gallery);
    }

    /* ==============================
       🔹 Cambio de variante
    ============================== */
    document.addEventListener('change', function (e) {

      const drawer = document.querySelector('#Product-Drawer.active');
      if (!drawer) return;

      const input = e.target.closest(
        '#Product-Drawer select[name="id"], #Product-Drawer input[name="id"]'
      );

      if (!input) return;

      updateQuickViewImages(drawer, input.value);

    });

    /* ==============================
       🔹 Detectar apertura del drawer
    ============================== */
    const drawerElement = document.getElementById('Product-Drawer');

    if (drawerElement) {

      const observer = new MutationObserver(function (mutations) {

        mutations.forEach(function (mutation) {

          if (mutation.attributeName === "class") {

            const drawer = document.querySelector('#Product-Drawer.active');
            if (!drawer) return;

            const variantInput = drawer.querySelector(
              'select[name="id"], input[name="id"]'
            );

            if (!variantInput) return;

            updateQuickViewImages(drawer, variantInput.value);

          }

        });

      });

      observer.observe(drawerElement, { attributes: true });

    }

  });

})();